export const WORKER_ROLES = ["Pharmacist", "Pharmacy Technician", "Pharmacy Clerk"];

export const SOFTWARE = [
  "MicroMerchant/MMS/PrimeRx",
  "BestRx",
  "LibertyRx",
  "PioneerRx",
  "Primecare QS/1",
  "Datascan",
  "Other",
  "Not specified",
];

export const PHARMACY_TYPES = ["Independent", "Specialty", "Compounding", "Other"];

export const LANGUAGES = ["English", "Spanish", "Russian", "Other"];

export const EXPERIENCE = [
  "Independent pharmacy",
  "Retail",
  "Hospital/inpatient",
  "Specialty",
  "Compounding",
  "Other",
];

export const WORK_TYPES = ["One-time coverage", "Multiple-day", "Temporary", "Permanent"];

export const COVERAGE_TYPES = [
  { value: "one-time", label: "One-time" },
  { value: "multiple-dates", label: "Multiple dates" },
  { value: "recurring", label: "Recurring" },
  { value: "temporary", label: "Temporary" },
  { value: "permanent", label: "Permanent" },
];

export const RADIUS_OPTIONS = [5, 10, 15, 25, 50];

export const ENVIRONMENT = [
  "Technician support available",
  "Other pharmacist available",
  "Parking available",
  "High workload",
  "Low workload",
  "Prescription verification only",
  "Other",
];

export const REQUIREMENTS_BY_ROLE = {
  Pharmacist: [
    "Active pharmacist license in the shift state",
    "1+ years experience",
    "Immunization certified",
    "Software experience required",
    "Bilingual preferred",
  ],
  "Pharmacy Technician": [
    "State registration in the shift state",
    "CPhT certification",
    "1+ years experience",
    "Software experience required",
    "Bilingual preferred",
  ],
  "Pharmacy Clerk": [
    "Customer service experience",
    "Prior pharmacy experience",
    "Software experience required",
    "Bilingual preferred",
  ],
};

export const RESPONSIBILITIES = [
  "Prescription verification",
  "Data entry",
  "Filling",
  "Patient counseling",
  "Immunizations",
  "Insurance calls",
  "Register",
  "Delivery coordination",
];

export const WEEKDAYS = [
  { value: 0, label: "Monday" },
  { value: 1, label: "Tuesday" },
  { value: 2, label: "Wednesday" },
  { value: 3, label: "Thursday" },
  { value: 4, label: "Friday" },
  { value: 5, label: "Saturday" },
  { value: 6, label: "Sunday" },
];
